<template>
  <div class="mb-[16px]">
    <label
      for="gambar-toko"
      class="text-[14px] mb-[8px] text-[#626262]"
    >Logo Gudang</label>
    <div
      :class="{'text-[#333333] p-[12px] rounded-[8px] border border-[#E2E2E2]': true,
               'bg-[#F4F4F4]': enableEditInput,
               'bg-[#FFFFFF]': !enableEditInput,
      }"
    >
      <input
        ref="fileInput"
        type="file"
        accept="image/jpeg, image/png, image/jpg, image/svg"
        hidden
        @change="handleChangeImage"
      >
      <div
        v-if="!form.image_logo_url"
        class="relative w-fit p-[4px]"
      >
        <button
          type="button"
          class="my-[4px] mx-auto size-[56px] flex items-center justify-center gap-[16px] border-dashed border-[2px] border-[#E2E2E2] bg-[#F8F8F8] transition-all duration-300 hover:bg-[#FFFFFF] rounded-[8px] p-[4px]"
          :disabled="enableEditInput"
          @click="handleAddImage"
        >
          <span class="k-add text-[24px]" />
        </button>
        <p class="text-[#828282] mb-0">
          Tambah Gambar
        </p>
      </div>
      <div
        v-else
        class="relative w-fit p-[4px]"
      >
        <b-img
          :src="form.image_logo_url || 'https://storage.googleapis.com/komerce/assets/icons/product-placehold.svg'"
          alt="logo"
          width="56"
          height="56"
        />
        <button
          type="button"
          class="absolute top-0 right-0 hover:bg-[#FFFFFF] rounded-[8px] size-[16px]"
          :disabled="enableEditInput"
          @click="handleRemoveImage"
        >
          <span class="k-close-circle" />
        </button>
      </div>
    </div>
    <small
      v-if="errorMessage"
      class="text-danger"
    >{{ errorMessage }}</small>
  </div>
</template>

<script>

export default {
  props: {
    form: {
      type: Object,
      required: true,
    },
    enableEditInput: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      errorMessage: '',
      rawFile: null,
    }
  },
  methods: {
    /**
     * Handle the add image so can be applied to the form
     */
    handleAddImage() {
      this.$refs.fileInput.click()
    },
    /**
     * Handle the change image so can be applied to the form and validate the image size
     * @param {Event} event - The event
     */
    handleChangeImage(event) {
      const file = event.target.files[0]
      const reader = new FileReader()
      if (file.size > 10 * 1024 * 1024) {
        this.errorMessage = 'Gambar Toko harus kurang dari 10MB'
        return
      }
      reader.onload = () => {
        this.form.image_logo_url = reader.result
        this.rawFile = file
        this.validate()
      }
      reader.readAsDataURL(file)
    },
    /**
     * Handle the remove image so can be applied to the form
     */
    handleRemoveImage() {
      this.form.image_logo_url = ''
      this.rawFile = null
      this.validate()
    },
    /**
     * Manually validate the image so can be applied to the form
     * @returns {Object} The validate
     */
    validate() {
      if (!this.form.image_logo_url) {
        this.errorMessage = 'Gambar Toko harus diisi'
        return {
          isValid: false,
          data: null,
        }
      }
      this.errorMessage = ''
      return {
        isValid: true,
        data: this.rawFile,
      }
    },
  },
}
</script>
